import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import SharedProductCardShoppingList from "../OldShoppingList/SharedProductCardShoppingList";
import SharedListComments from "../OldShoppingList/SharedListComments";
import ListComments from "../OldShoppingList/ListComments";
import useModalStore from "../StatesStore/ModalStore";
import EmptyList from "../OldShoppingList/EmptyList";
import SideNavUserProfile from "../SideNav/SideNavUserProfile";
import useSocketStore from "../StatesStore/Socket";

function SharedShoppingLists() {
  const [shoppingListData, setShoppingListData] = useState([]);
  const [selectedShopList, setSelectedShopList] = useState("");
  const [visibility, setVisibility] = useState("");
  const [friends, setFriends] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Add loading state
  const { openModal, closeModal } = useModalStore();
  const { user } = UserAuth();
  let { listId, userId } = useParams();
  
  // Check if user is logged in
  const isLoggedIn = !!user;
  const currentUserId = user?.uid;

  useEffect(() => {
    const fetchShoppingLists = async () => {
      try {
        setIsLoading(true); // Set loading to true when starting fetch
        const userRef = doc(db, "users", userId);
        const shoppingListRef = collection(userRef, "shoppingList");

        // Query for the specific document with matching listId
        const q = query(shoppingListRef, where("listId", "==", listId));

        // Set up a listener for the specific shopping list document
        const unsubscribe = onSnapshot(q, async (querySnapshot) => {
          if (!querySnapshot.empty) {
            const docSnap = querySnapshot.docs[0];
            const data = docSnap.data();
            const dateCreated =
              data.dateCreated?.seconds || new Date().getTime() / 1000;

            const productRef = collection(docSnap.ref, "products");
            const productDocs = await getDocs(productRef);

            const products = productDocs.docs.map((productDoc) => ({
              id: productDoc.id,
              ...productDoc.data(),
            }));

            const visibility = data.visibility || "";
            // Fetch friends from the members subcollection
            const membersRef = collection(docSnap.ref, "members");
            const membersSnapshot = await getDocs(membersRef);
            const friends = membersSnapshot.docs.map((memberDoc) => ({
              id: memberDoc.id,
              ...memberDoc.data(),
            }));

            setVisibility(visibility);
            setFriends(friends);

            const shoppingList = {
              name: docSnap.id,
              dateCreated,
              products,
              visibility,
              friends,
              listId: data.listId,
            };

            setShoppingListData([shoppingList]);
          } else {
            console.log("No such document with the specified listId!");
            setShoppingListData([]);
          }
          setIsLoading(false); // Set loading to false after data is fetched
        });

        return () => unsubscribe();
      } catch (error) {
        console.error("Error fetching shopping list:", error);
        setIsLoading(false); // Set loading to false on error
      }
    };

    window.scrollTo(0, 0);
    fetchShoppingLists();
  }, [listId, userId]);

  useEffect(() => {
    if (shoppingListData?.length > 0) {
      setSelectedShopList(shoppingListData[0].name);
    } else {
      setSelectedShopList("");
    }
  }, [shoppingListData, listId, userId]);

  const handleshopListClick = (shopListName) => {
    setSelectedShopList(shopListName);
  };

  // Safely check view permissions
  const canViewProducts = 
    !isLoggedIn ? visibility === "Public" : // If not logged in, only public lists are visible
    currentUserId === userId || // Owner can always view
    visibility === "Public" || // Public lists are visible to everyone
    (visibility === "Friends" && friends.some(friend => friend.id === currentUserId)); // Friends can view friend lists

  // Show loading state while data is being fetched
  if (isLoading) {
    return (
      <div className="col-md-8 col-lg-6 vstack gap-4">
        <div className="card-header d-sm-flex text-center align-items-center justify-content-between border-0 pb-0">
          <div className="" style={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: "24px",
              lineHeight: "112%",
              letterSpacing: "0%",
              color: "black",
            }}></div>
        </div>
        <div className="card-body">
          <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="col-md-8 col-lg-6 vstack gap-4">
        <div className="">
          <div className="card-header d-sm-flex text-center align-items-center justify-content-between border-0 pb-0">
            {/* <div className="" style={{
              marginTop: "10px",
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: '24px'
            }}>Shopping List</div> */}
          </div>
        </div>
       
        {/* Card header START */}
        <div className="card-header d-sm-flex text-center align-items-center justify-content-between border-0 pb-0">
          <div className="" style={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: "24px",
              lineHeight: "112%",
              letterSpacing: "0%",
              color: "black",
            }}>{selectedShopList ?? ""}</div>
        </div>
        
        {/* Card body START */}
        <div className="card-body">
          <div className="row g-4">
            {canViewProducts ? (
              shoppingListData
                .filter((shopList) => shopList?.name === selectedShopList)
                .map((shopList) => (
                  <SharedProductCardShoppingList
                    key={shopList?.name}
                    listName={shopList?.name}
                    userId={userId}
                    visibility={visibility}
                    friends={friends}
                    shoppingListData={shoppingListData}
                    selectedShopList={selectedShopList}
                    listId={listId}
                    ownerId={userId}
                  />
                ))
            ) : (
              // <EmptyList
              //   content={isLoggedIn 
              //     ? "You do not have access to view this list" 
              //     : "Please sign in to view this list"}
              // />
                <div style={{ height: "25rem", maxHeight: "25rem" }}>
            <div
              className={`h-100 d-flex justify-content-center align-items-center flex-column px-5`}
              style={{
                minHeight: "10vh", // Make it fill the full viewport height
                height: "25rem",
                maxHeight: "25rem",
                width: "100%",
                gap: "24px",
              }}
            >
              <svg
                style={{
                  width: "110px",
                }}
                width="141"
                height="141"
                viewBox="0 0 141 141"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2"
                  width="137"
                  height="137"
                  rx="68.5"
                  stroke="#676A79"
                  strokeWidth="3"
                />
                <path
                  d="M101 49.3118V97.9365C101 104.143 96.5429 106.754 91.1 103.758L74.2572 94.3839C72.4572 93.3994 69.5428 93.3994 67.7428 94.3839L50.9 103.758C45.4571 106.754 41 104.143 41 97.9365V49.3118C41 41.9924 47 36 54.3285 36H87.6714C95 36 101 41.9924 101 49.3118Z"
                  stroke="#676A79"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <div
                style={{
                  whiteSpace: "normal",
                  width: "100%",
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "24px",
                  color: "#676A79",
                  textAlign: "center",
                  padding: "0 20rem",
                }}
              >
                {isLoggedIn 
                  ? "You do not have access to view this list" 
                  : "Not a Public List"}
                {/* No List Yet */}
              </div>
            </div>
          </div>
            )}
          </div>
        </div>
        
        {/* Only show comments if user is logged in and has view permissions */}
        {isLoggedIn && canViewProducts && (
          <SharedListComments
            listId={listId}
            userId={currentUserId}
            visibility={visibility}
            friends={friends}
            shoppingListData={shoppingListData}
            setShoppingListData={setShoppingListData}
            selectedShopList={selectedShopList}
            ownerId={userId}
          />
        )}
      </div>
    </>
  );
}

export default SharedShoppingLists;